export default __webpack_public_path__ + "static/media/Logo-Light.49fa12fc.svg";